export const APP_CONFIG = {
    mensajes: {
        pregunta: {
          titulo: '¿Esta seguro?'
        },
        respuesta_ok: {
          titulo: 'Realizado'
        },
        respuesta_err: {
          titulo: 'Error'
        },
        cargando: {
            titulo: 'Espere',
            texto: 'Cargando datos...',
        },
        enviando: {
          titulo: 'Espere',
          texto: 'Enviando datos...'
        }
    },
    botones: {
        crear: {
            texto: 'Crear',
            icono: 'fa fa-plus',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-primary',
                icon: 'btn-outline-secondary'
            },
            tooltip: ''
        },
        guardar: {
            texto: 'Guardar',
            icono: 'fa fa-save',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-azul',
                icon: ''
            },
            tooltip: 'Guardar'
        },
        editar: {
            texto: 'Editar',
            icono: 'fa fa-edit',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-azul',
                icon: 'btn-outline-azul'
            },
            tooltip: 'Editar'
        },
        modificar: {
            texto: 'Modificar',
            icono: 'fa fa-edit',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-primary',
                icon: 'btn-outline-primary'
            },
            tooltip: 'Modificar'
        },
        agregar: {
            texto: 'Agregar',
            icono: 'fa fa-plus-circle',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-success',
                icon: 'success'
            },
            tooltip: ''
        },
        agregar_items: {
            texto: 'Agregar',
            icono: 'fa fa-bars',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-success',
                icon: 'btn-outline-purple'
            },
            tooltip: 'Agregar'
        },
        agregar_archivos: {
            texto: 'Agregar',
            icono: 'fa fa-upload',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-outline-purple',
                icon: 'btn-outline-purple'
            },
            tooltip: 'Agregar'
        },
        eliminar_archivos: {
            texto: 'Eliminar',
            icono: 'fa fa-trash',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-danger',
                icon: 'btn-outline-danger'
            },
            tooltip: 'Eliminar'
        },
        descargar_archivos: {
            texto: 'Descargar',
            icono: 'fa fa-download',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-outline-purple',
                icon: 'btn-outline-purple'
            },
            tooltip: 'Descargar'
        },
        eliminar: {
            texto: 'Eliminar',
            icono: 'fa fa-trash',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-danger',
                icon: 'btn-outline-danger'
            },
            tooltip: 'Eliminar'
        },
        bloquear: {
            texto: 'Bloquear',
            icono: 'fa fa-lock',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-maroon',
                icon: 'btn-outline-maroon'
            },
            tooltip: 'Bloquear'
        },
        salir: {
            texto: '',
            icono: 'fa fa-angle-double-left',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-default',
                icon: ''
            },
            tooltip: 'Salir'
        },
        ver: {
            texto: 'Ver',
            icono: 'fa fa-eye',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-yellow',
                icon: 'btn-outline-yellow'
            },
            tooltip: 'Ver'
        },
        descargar: {
            texto: 'Descargar',
            icono: 'fa fa-download',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-purple',
                icon: 'btn-outline-purple'
            },
            tooltip: 'Descargar'
        },
        validar: {
            texto: 'Validar',
            icono: 'fa fa-check-circle',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-success',
                icon: 'btn-outline-success'
            },
            tooltip: 'Validar'
        },
        buscar: {
            texto: 'Buscar',
            icono: 'fa fa-search',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-magenta',
                icon: 'magenta'
            },
            tooltip: 'Buscar'
        },
        filtrar: {
            texto: 'Filtrar',
            icono: 'fa fa-filter',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-sky',
                icon: 'primary'
            },
            tooltip: 'Filtrar'
        },
        anular_filtro: {
            texto: 'Anular Filtros',
            icono: 'fa fa-ban',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-default',
                icon: 'maroon'
            },
            tooltip: 'Anular'
        },
        /* activar: {
            texto: 'Activar',
            icono: 'fa fa-check-circle-o',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-success',
                icon: 'text-success'
            },
            tooltip: 'Si'
        }, */
        /* desactivar: {
            texto: 'Desactivar',
            icono: 'fa fa-times-circle-o',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-danger',
                icon: 'text-danger'
            },
            tooltip: 'No'
        }, */
        /* imprimir: {
            texto: 'Imprimir',
            icono: 'fa fa-print',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-azure',
                icon: 'azure'
            },
            tooltip: 'Imprimir'
        }, */
        imprimirpdf: {
            texto: 'Imprimir PDF',
            icono: 'fa fa-print',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-sky2',
                icon: 'azure'
            },
            tooltip: 'Imprimir PDF'
        },
        generarpdf: {
            texto: 'Generar PDF',
            icono: 'fa fa-file-pdf-o',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-outline-dark',
                icon: 'azure'
            },
            tooltip: 'Generar PDF'
        },
        exportarexcel: {
            texto: 'Exportar Excel',
            icono: 'fa fa-file-excel-o',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-outline-dark',
                icon: 'btn-azure'
            },
            tooltip: 'Exportar a excel'
        },
        importar: {
            texto: 'Importar',
            icono: 'fa fa-upload',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-dark',
                icon: 'btn-azure'
            },
            tooltip: 'Importar'
        },
        generar_qr: {
            texto: 'Generar RQ',
            icono: 'fa fa-qrcode',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-dark',
                icon: 'btn-azure'
            },
            tooltip: 'Generar Tarjeta QR'
        },
        registrar: {
            texto: 'Registrar Ingreso',
            icono: 'fa fa-clock-o',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-sky',
                icon: 'btn-sky'
            },
            tooltip: 'Registrar Ingreso'
        },
        salida: {
            texto: 'Registrar Salida',
            icono: 'fa fa-external-link-square',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-sky',
                icon: 'btn-sky'
            },
            tooltip: 'Registrar Salida'
        },
        /* editar: {
            texto: 'Editar',
            icono: 'fa fa-edit',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-azul',
                icon: 'btn-outline-azul'
            },
            tooltip: 'Editar'
        }, */
        /* representante: {
            texto: 'Representante Legal',
            icono: 'fa fa-user-plus',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-darkorange',
                icon: 'darkorange'
            },
            tooltip: 'Representante Legar'
        }, */
        /* adjuntar: {
            texto: 'Seleccionar',
            icono: 'fa fa-image',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-purple',
                icon: 'purple'
            },
            tooltip: ''
        }, */
        /* confirmar: {
            texto: 'Confirmar',
            icono: 'glyphicon glyphicon-ok-sign',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-sky',
                icon: 'sky'
            },
            tooltip: 'Confirmar'
        }, */
        cerrar: {
            texto: 'Cerrar',
            icono: 'fa fa-lock',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-dark',
                icon: 'dark'
            },
            tooltip: 'Cerrar'
        },
        /* anular: {
            texto: 'Anular',
            icono: 'fa fa-ban',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-default',
                icon: 'maroon'
            },
            tooltip: 'Anular'
        }, */
        anular: {
            texto: 'Anular',
            icono: 'fa fa-ban',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-maroon',
                icon: 'maroon'
            },
            tooltip: 'Anular'
        },
        rechazar: {
            texto: 'Rechazar',
            icono: 'fa fa-ban',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-maroon',
                icon: 'maroon'
            },
            tooltip: 'Rechazar'
        },
        cancelar: {
            texto: 'Cancelar',
            icono: 'fa fa-close',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-light',
                icon: 'maroon'
            },
            tooltip: ''
        },
        acciones: {
            texto: 'Más acciones',
            icono: 'fa fa-gear',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-default',
                icon: 'btn-default'
            },
            tooltip: 'Más acciones'
        },
        /* rechazar: {
            texto: 'Rechazar',
            icono: 'fa fa-ban',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-maroon',
                icon: 'maroon'
            },
            tooltip: 'Rechazar'
        }, */
        /* revisar: {
            texto: 'Revisar',
            icono: 'fa fa-check-circle',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-success',
                icon: 'success'
            },
            tooltip: 'Revisar'
        }, */
        /* rendir: {
            texto: 'Rendir',
            icono: 'fa fa-check-square-o',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-yellow',
                icon: 'yellow'
            },
            tooltip: 'Rendir'
        }, */
        /* vistobueno: {
            texto: 'VB',
            icono: 'fa fa-check-square-o',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-orange',
                icon: 'orange'
            },
            tooltip: 'VB'
        }, */
        enviarpdf: {
            texto: 'Enviar PDF',
            icono: 'fa fa-envelope',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-sky2',
                icon: 'azure'
            },
            tooltip: 'Enviar PDF'
        },
        enviar: {
            texto: 'Enviar',
            icono: 'fa fa-send',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-primary',
                icon: 'btn-outline-primary'
            },
            tooltip: 'Enviar PDF'
        },
        /* avisomail: {
            texto: '',
            icono: 'fa fa-envelope',
            tamanio: {
                btn: 'btn-sm',
                icon: 'btn-xs'
            },
            color: {
                btn: 'btn-outline-dark',
                icon: 'azure'
            },
            tooltip: ''
        }, */
    }
}
